
import { FormElementController, FormPageValidator, FormElementValidator, StringValidators } from './../../../scripts/formcontrols'
import { AddressDto } from "./../../../dto/address"

import { AddressEditorController } from "./addressEditorController"

export class AddressGroupController extends FormPageValidator {

    public items: AddressEditorController[];

    constructor(addresses: AddressDto[]) {
        super();
    }

    public addNew() {
        this.items.push(new AddressEditorController(new AddressDto()));
    }
}


// WEBPACK FOOTER //
// ./ClientApp/components/appcontrols/addressEditor/addressGroupEditorController.ts